export default __webpack_public_path__ + "static/media/JP5-2.f5186ba7.jpg";